import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cf1d364a: FaireBrandEntity = {
  token: "b_cf1d364a",
  type: "brand",
  name: "Hartland Cards",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/d268c7d23c7ad3f72515dbccaa5043b462de70e3849ef776ee4fd28f67483353/1532439479.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0d19f1dc8472c635dd14b5351ba8bc4b4f64f49044b77ec17a7feb96d9cb0151.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/d268c7d23c7ad3f72515dbccaa5043b462de70e3849ef776ee4fd28f67483353/1532439479.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0d19f1dc8472c635dd14b5351ba8bc4b4f64f49044b77ec17a7feb96d9cb0151.jpeg",
  location: "Leeds, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 125,
  isTopShop: true,
  isInsider: true,
  description:
    'Established in 2012, Emily Johnson started Hartland Cards (formerly Hartland Brooklyn) while working as a designer in NYC. What started as a way to be creative, soon turned into a full time job when the line was picked up by a big box store.  Since then we\'ve worked with all kinds of shops in the US and around the world.  We hold true to our commitment to making quality products, being eco-friendly, sending joy, and giving back.  \n\nOur greeting cards are printed on a 100% carbon neutral printing press here in New York.\n\nWe print with eco-friendly vegetable based inks and neon pigments, on the highest quality felted FSC certified paper.\nOur paper is 100% recycled.\n\nEnvelopes are made from 100% post-consumer paper bags. We use bio sleeves made from plant-based PLA.\nWe strive to use sustainable, and recycled materials whenever possible, and always print in the USA.\n\nAll products are designed, packed, and shipped from our studio in Leeds, New York with livable wage standards, ZERO AI, and good vibes.\n\n*We display all cards at our retail shop without plastic sleeves. Please consider making a change and say no to plastic/oil.\nSee "Plastic Free / Ship Cello Free / Kard Klasp or Naked" listing for more information.',
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:09.856Z",
    importedBy: "entity-db-cli",
  },
};
